import {
  FaReact, FaNodeJs, FaPython, FaGitAlt, FaCss3Alt, FaJira
} from 'react-icons/fa';
import {
  SiTypescript, SiJavascript, SiFirebase, SiTailwindcss,
  SiRedux, SiElectron, SiExpo
} from 'react-icons/si';

export const skillGroups = ["Mobil", "Diller", "Sunucu & Veri", "Araçlar"];

export const skillsData = [
  { name: "React Native", group: "Mobil", icon: <FaReact />, color: "#61DAFB" },
  { name: "React JS", group: "Mobil", icon: <FaReact />, color: "#61DAFB" },
  { name: "Expo", group: "Mobil", icon: <SiExpo />, color: "#000020" },
  { name: "Redux", group: "Mobil", icon: <SiRedux />, color: "#764ABC" },
  { name: "Electron", group: "Mobil", icon: <SiElectron />, color: "#47848F" },

  { name: "TypeScript", group: "Diller", icon: <SiTypescript />, color: "#3178C6" },
  { name: "JavaScript", group: "Diller", icon: <SiJavascript />, color: "#F7DF1E" },
  { name: "Python", group: "Diller", icon: <FaPython />, color: "#3776AB" },

  { name: "Node.js", group: "Sunucu & Veri", icon: <FaNodeJs />, color: "#339933" },
  { name: "Firebase", group: "Sunucu & Veri", icon: <SiFirebase />, color: "#FFCA28" },

  { name: "Git", group: "Araçlar", icon: <FaGitAlt />, color: "#F05032" },
  { name: "Jira", group: "Araçlar", icon: <FaJira />, color: "#0052CC" },
  { name: "Tailwind CSS", group: "Araçlar", icon: <SiTailwindcss />, color: "#06B6D4" },
  { name: "CSS3", group: "Araçlar", icon: <FaCss3Alt />, color: "#1572B6" },
];
